import { createSelector } from "reselect"
import { get, pick } from "lodash"
import { getRawTopic } from "modules/research-topic-root/selectors"

const EMPTY_OBJECT = {}

export const getSecurityInstrumentData = (state) => get(state, "global.data.instrumentDescriptors.data.model.security")
export const getInstrument = (state, props) => get(props, "currentTopic.referenceInstrument")
export const getRefInstrumentEvaluateAs = (state) => get(state, "modules.researchTopic.refInstrumentEvaluateAs")
export const getInstrumentPortfolio = state => get(state, "global.data.instrumentPortfolio.data.portfolio", EMPTY_OBJECT)

export const getInstrumentDescriptors = createSelector(
  [getSecurityInstrumentData],
  (instrumentData) => get(instrumentData, "descriptors"),
)

export const getInstrumentType = createSelector(
  [getRawTopic],
  (topic) => {
    const { securityId, portfolioId } = get(topic, "referenceInstrument", {})
    if (securityId) { return "security" }
    if (portfolioId) { return "portfolio" }
    return null
  })

const getSecurityId = createSelector(
  [getRawTopic],
  (topic) => get(topic, "referenceInstrument.securityId"),
)

const getSecurityInstrument = createSelector(
  [getSecurityId, getInstrumentDescriptors, getRefInstrumentEvaluateAs],
  (securityId, descriptors, evaluateAs) => {
    if (!descriptors) {
      return null
    }

    return {
      id: `${securityId.ticker}.${securityId.mic}`,
      type: "security",
      evaluateAs,
      isRefInstrument: true,
      ...descriptors,
    }
  })

const getPortfolioId = createSelector(
  [getRawTopic],
  (topic) => get(topic, "referenceInstrument.portfolioId"),
)

const getPortfolioInstrument = createSelector(
  [getPortfolioId, getInstrumentPortfolio, getRefInstrumentEvaluateAs],
  (portfolioId, instrumentPortfolio, evaluateAs) => ({
    id: portfolioId,
    type: "portfolio",
    label: instrumentPortfolio.name,
    ...pick(instrumentPortfolio, ["name", "alias", "fxHedgeEnabled"]),
    evaluateAs,
    isRefInstrument: true,
  }),
)

// Delegates to the memoized security/portfolio selector for the active instrument type only —
// running the inactive branch would build an id off the absent securityId/portfolioId and throw.
export const getRefInstrument = (state, props) => getInstrumentType(state, props) === "security"
  ? getSecurityInstrument(state, props)
  : getPortfolioInstrument(state, props)

export const getIsRefInstrumentUnmodeled = createSelector(
  [getRefInstrument],
  (instrument) => get(instrument, "unmodeled", false),
)
